import { Theme } from '@material-ui/core/styles';
import { createStyles, makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogTitle: {
      padding: 0
    },
    flexRight: {
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'flex-end',
      gap: theme.spacing(2)
    },
    storyButton: {
      height: '41px'
    }
  })
);

export default useStyles;
